import { IState } from '../../store';

export const selectIsBookedFromDeveloper = (state: IState): boolean => {
  return Boolean(state.offerData.isBookedFromDeveloper);
};
